module.exports.excalibur = {
  vi: {
    title: 'Excalibur trong Avalon: luật, đổi thẻ và ví dụ',
    description:
      'Cách Excalibur hoạt động trong Avalon: ai nhận kiếm, khi nào đổi Thành công hoặc Thất bại, ai thấy kết quả và vì sao đổi thẻ chưa chắc cứu được Nhiệm vụ.',
    keywords: ['Excalibur trong Avalon', 'Luật chơi', 'Đổi thẻ'],
  },
  pt: {
    title: 'Excalibur em Avalon: regras e troca da carta de missão',
    description:
      'Quem recebe Excalibur, quando Sucesso vira Fracasso, quem vê a carta alterada e por que a espada nem sempre salva uma missão em Avalon.',
    keywords: ['Excalibur em Avalon: regras e troca da carta de missão'],
  },
  en: {
    title: 'Excalibur in Avalon: rules, card flips and examples',
    description:
      'How Excalibur works in Avalon: who gets the sword, when it flips Success or Fail, who sees the result, and why a flip may not save the mission.',
    keywords: ['Excalibur in Avalon: rules, card flips and examples'],
  },
  ru: {
    title: 'Экскалибур в Авалоне: правила и смена карты миссии',
    description:
      'Кому дают Экскалибур, когда он меняет успех на провал, кто видит результат и почему применение меча не всегда спасает миссию в Авалоне.',
    keywords: ['Экскалибур в Авалоне: правила и смена карты миссии'],
  },
  'zh-CN': {
    title: '阿瓦隆王者之剑 Excalibur：翻转任务牌规则',
    description: '阿瓦隆神剑交给谁、何时把成功变为失败、谁能看到结果？通过实例了解 Excalibur 的任务牌翻转和限制。',
    keywords: ['阿瓦隆王者之剑 Excalibur：翻转任务牌规则'],
  },
  'zh-TW': {
    title: '阿瓦隆王者之劍 Excalibur：翻轉任務牌規則',
    description: '阿瓦隆神劍交給誰、何時把成功變為失敗、誰能看到結果？透過實例了解 Excalibur 的任務牌翻轉和限制。',
    keywords: ['阿瓦隆王者之劍 Excalibur：翻轉任務牌規則'],
  },
  es: {
    title: 'Excalibur en Avalon: reglas y cambio de carta de misión',
    description:
      'Quién recibe Excalibur, cuándo cambia Éxito por Fracaso, quién ve la carta y por qué la espada no siempre salva una misión de Avalon.',
    keywords: ['Excalibur en Avalon: reglas y cambio de carta de misión'],
  },
};
